import { observer } from '@formily/reactive-react';
import { TOOLBAR_GROUPS } from '../../../components/Editor/config/registry';
import { type IFormFieldSchema } from '../../types';
import EditorForRunTime from './EditorForRunTime';
import EditorForPreview from './EditorForPreview';

export interface IFormEditorProps {
  disabled?: boolean;
  visible?: boolean;
  height?: string;
  placeholder?: string;
  menubar?: boolean;
  statusbar?: boolean;
  branding?: boolean;
  toolbarGroups?: (keyof typeof TOOLBAR_GROUPS)[];
  templateEnabled?: boolean;
  downloadEnabled?: boolean;
  templateVisible?: boolean;
  templateIds?: string[];
  templateDataMapping?: string;
}

interface IProps {
  schema?: IFormFieldSchema<IFormEditorProps>;
}

const FormEditor = observer(({ schema }: IProps = {}) => {
  // edit mode: use schema props
  if (schema) {
    return <EditorForPreview schema={schema} />;
  }

  // runtime mode: use Formily field
  return <EditorForRunTime />;
});

export default FormEditor;
